var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFibrateFailure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 460,
    viewBox: "0 0 460 460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 230.13,
    cy: 229.631,
    rx: 229.679,
    ry: 229.679,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.621 134.595C108.822 134.595 104.932 138.484 104.932 143.284V323.884C104.932 328.684 108.822 332.573 113.621 332.573H347.175C351.975 332.573 355.864 328.684 355.864 323.884V143.284C355.864 138.484 351.975 134.595 347.175 134.595H296.804V125.393H347.175C357.057 125.393 365.067 133.402 365.067 143.284V323.884C365.067 333.766 357.057 341.775 347.175 341.775H113.621C103.739 341.775 95.73 333.766 95.73 323.884V143.284C95.73 133.402 103.739 125.393 113.621 125.393H255.415V134.595H113.621Z",
    fill: "url(#paint0_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.322 168.881H144.127V289.66H135.5V298.287H325.297V289.66H316.67V237.898H286.475V289.66H269.22V220.643H239.025V289.66H221.771V203.389H191.576V289.66H174.322V168.881V168.881ZM152.754 177.508H165.695V289.66H152.754V177.508ZM295.102 246.525H308.042V289.66H295.102V246.525ZM247.653 229.27H260.593V289.66H247.653V229.27ZM200.203 212.016H213.144V289.66H200.203V212.016Z",
    fill: "url(#paint1_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.655 226.197L306.747 232.289L322.761 216.275L306.747 200.26L300.655 206.352L305.94 211.637C280.327 210.127 255.256 203.387 232.34 191.847L228.457 199.559C252.774 211.798 279.357 218.863 306.533 220.317L300.655 226.195V226.197Z",
    fill: "url(#paint2_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.198 161.321L281.869 99.1042C280.537 96.8842 278.197 95.5614 275.611 95.5614C273.026 95.5614 270.684 96.8842 269.354 99.1042L232.02 161.321C230.651 163.605 230.617 166.352 231.928 168.671C233.239 170.988 235.611 172.373 238.275 172.373H312.938C315.602 172.373 317.974 170.988 319.288 168.671C320.599 166.352 320.564 163.608 319.193 161.321H319.198ZM238.278 165.078L275.609 102.856L312.94 165.075H238.275L238.278 165.078Z",
    fill: "url(#paint3_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.96 124.951V139.541C271.96 141.547 273.601 143.19 275.607 143.19C277.613 143.19 279.255 141.547 279.255 139.541V124.951C279.255 122.943 277.613 121.305 275.607 121.305C273.601 121.305 271.96 122.943 271.96 124.951Z",
    fill: "url(#paint4_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.609 150.485C273.601 150.485 271.963 152.125 271.963 154.134C271.963 156.142 273.603 157.78 275.609 157.78C277.615 157.78 279.258 156.138 279.258 154.134C279.258 152.13 277.615 150.485 275.609 150.485Z",
    fill: "url(#paint5_linear_0_1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 88.2186,
    y1: 315.673,
    x2: 372.578,
    y2: 151.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0E246F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0E406F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5A59A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#575CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4F67A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4279B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3092C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#18B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16B7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 132.286,
    y1: 292.72,
    x2: 294.313,
    y2: 199.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0E246F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0E406F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5A59A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#575CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4F67A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4279B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3092C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#18B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16B7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 244.146,
    y1: 226.733,
    x2: 307.635,
    y2: 190.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0E246F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0E406F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5A59A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#575CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4F67A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4279B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3092C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#18B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16B7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 232.49,
    y1: 169.64,
    x2: 301.122,
    y2: 130.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0E246F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0E406F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5A59A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#575CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4F67A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4279B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3092C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#18B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16B7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 269.294,
    y1: 135.893,
    x2: 281.924,
    y2: 128.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0E246F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0E406F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5A59A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#575CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4F67A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4279B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3092C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#18B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16B7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 272.453,
    y1: 155.956,
    x2: 278.768,
    y2: 152.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0E246F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0E406F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5A59A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#575CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4F67A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4279B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3092C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#18B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16B7E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 540,
    fill: "white",
    transform: "translate(-34 -34.4999)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFibrateFailure);
export default __webpack_public_path__ + "static/media/fibrate-failure.9a0330aae01caad5b4d0c8b4eaf52e3f.svg";
export { ForwardRef as ReactComponent };